import { useState } from "react";
import { getThemeMap } from "./helpers/themeMap";

// Thumbs
export const useThemeThumbs = () => {
	// Returns a map of [file, id]
	const thumbs = require.context("./thumbs", false);
	return Array.from(getThemeMap(thumbs));
};

export const useThemeImages = () => {
	// Returns a map of [file, id]
	const thumbs = require.context("./images", false);
	return getThemeMap(thumbs);
};

export const useThemePreviews = () => {
	// Returns a map of [file, id]
	const thumbs = require.context("./previews", false);
	return getThemeMap(thumbs);
};

export const useTheme = () => {
	const image = useThemeImages();
	const defaultImage = image.keys().next().value;

	const initialTheme = {
		landingScreenImage: defaultImage,
	};
	const [theme, setTheme] = useState(initialTheme);

	const updateTheme = {
		landingScreenImage: (name: string) => {
			setTheme({
				...theme,
				landingScreenImage: name,
			});
		},
		reset: () => {
			setTheme({
				...theme,
				landingScreenImage: defaultImage,
			});
		},
	};

	return { theme, updateTheme };
};
